import getApiClient from '@/plugins/api-client'

export default {
  openRefundFile: function (refund) {
    const url = `${process.env.VUE_APP_API_URL}${refund['@id']}/file`
    window.open(url, '_blank')
  },

  reply: function (refund, status) {
    const self = this
    const api = getApiClient(self.$store)

    self.$store.state.loading = true

    api.patch(refund['@id'], {
      status
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(result => {
        refund = result.data
        self.$emit('refundUpdated', refund)
      })
      .catch(() => {})
      .finally(() => {
        self.$store.state.loading = false
      })
  },

  downloadRefundReport: function (event) {
    const self = this
    const api = getApiClient(self.$store)

    self.$store.state.loading = true
    api.get(`${event['@id']}/refund_report`, {responseType: 'blob'})
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data])),
          link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${event.name} - Relatório de reembolsos - Castfy.pdf`)
        document.body.appendChild(link)
        link.click()
      })
      .catch(() => {})
      .finally(() => {
        self.$store.state.loading = false
      })
  }
}
